import React, { useState, useEffect } from 'react';
import '../App.css'

import { HomeDataContext } from "../contexts/HomeDataContext";
import { homeDataService } from "../services/HomeDataService";
function LoadingOverlay() {
  return (
    <div className="fixed top-0 left-0 w-full h-full bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="loading-spinner w-12 h-12 rounded-full border-t-4 border-blue-500 animate-spin"></div>
    </div>
  );
}

var url = process.env.REACT_APP_URL || "http://localhost:8080/";
function Prompts() {

  const [filteredQrCodes, setFilteredQrCodes] = useState([]);
    const [searchCampaign, setSearchCampaign] = useState('');  // State to keep track of the search input

  const [loading, setLoading] = useState(false);
  const [qrCodes, setQrCodes] = useState([]);
  const [editId, setEditId] = useState(null);
  const [editLink, setEditLink] = useState("");
  const [editText, setEditText] = useState("");
  const [editCampaign, setEditCampaign] = useState("");
  const [campaign, setCampaign] = useState("");
  const [videoFile, setVideoFile] = useState(null);
  const [videoFileChanged, setVideoFileChanged] = useState(null);

  const [qrCode, setQrCode] = useState("");
  const [link, setLink] = useState("");
  const [text, setText] = useState("");
  const { homeDataState, dispatch } = React.useContext(HomeDataContext);

  useEffect(() => {
    async function fetchQrCodes() {
      const response = await fetch(`${process.env.REACT_APP_URL || "http://localhost:8080/"}api/pnl/tour/d-id/getallqrcodes`);
      const data = await response.json();
      console.log(data)
      setQrCodes(data); 
      setFilteredQrCodes(data); 
    }
    fetchQrCodes();
  }, []);

  useEffect(() => {
    const filtered = qrCodes.filter(qrCode => 
        qrCode.campaign ? qrCode.campaign.toLowerCase().includes(searchCampaign.toLowerCase()) : false
    );
    setFilteredQrCodes(filtered);
}, [searchCampaign, qrCodes]);
const handleSearchChange = (event) => {
  setSearchCampaign(event.target.value);
};
  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file && file.type.startsWith('video/')) {
      setVideoFile(file);
    } else {
      alert('Please select a video file.');
      setVideoFile(null);
    }
  };




  const handleFileChange1 = (event) => {
    const file = event.target.files[0];
    if (file && file.type.startsWith('video/')) {
      setVideoFileChanged(file);
    } else {
      alert('Please select a video file.');
      setVideoFileChanged(null);
    }
  };

  const handleEdit = (qrCode) => {
    setEditId(qrCode.id);
    setEditLink(qrCode.link);
    setEditText(qrCode.text);
    setEditCampaign(qrCode.campaign)
  };


  const handleSave = async (id) => {

    setLoading(true);

    if (videoFileChanged) {

      try {
        // Fetch the pre-signed URL from your backend ${url}api/pnl/tour/d-id/qrcodevideo
        const response = await fetch(`${url}api/pnl/tour/d-id/generate-presigned-url?fileName=${encodeURIComponent(videoFileChanged.name)}`);
        const data = await response.json();
        const preSignedUrl = data.url;


        console.log(preSignedUrl)
        // Upload the video file to S3
        const uploadResponse = await fetch(preSignedUrl, {
          method: 'PUT',
          headers: {
            'Content-Type': 'video/mp4',
          },
          body: videoFileChanged,
        });

        if (uploadResponse.ok) {
          console.log(data.name)
          const qrcodeResponse = await fetch(`${url}api/pnl/tour/edit/qrcodevideo`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              name: data.name,
              link: editLink,
              text: editText,
              campaign: editCampaign,
              id: editId

            }),
          });

          if (qrcodeResponse.ok) {
            console.log(qrcodeResponse)
            const qrCodeText = await qrcodeResponse.text(); // Use .text() for plain text response
            console.log(qrCodeText); // Logging the QR code text

            alert("Update successfull")
            window.location.reload()

          }

          setEditId(null);
          // Here, you might want to generate and set the QR code based on the uploaded video
        } else {
          alert('Upload failed');
        }
      
   
  } catch (error) {

    console.error('Error uploading video:', error);
    alert('Error uploading video.');
  } finally {
    setEditId(null);
    setLoading(false);
  }


}else{
  try {
    // Fetch the pre-signed URL from your backend ${url}api/pnl/tour/d-id/qrcodevideo
   
      const qrcodeResponse = await fetch(`${url}api/pnl/tour/edit/qrcodevideo`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          name: "",
          link: editLink,
          text: editText,
          campaign: editCampaign,
          id: editId

        }),
      });

      if (qrcodeResponse.ok) {
        console.log(qrcodeResponse)
        const qrCodeText = await qrcodeResponse.text(); // Use .text() for plain text response
        console.log(qrCodeText); // Logging the QR code text

        alert("Update successfull")
        window.location.reload()

      }

      setEditId(null);
      // Here, you might want to generate and set the QR code based on the uploaded video
  
} catch (error) {

console.error('Error uploading video:', error);
alert('Error uploading video.');
} finally {
setEditId(null);
setLoading(false);
}
}
};

const renderEditableFields = (qrCode) => {
  return (
      <div className="flex flex-wrap items-center w-full gap-4">
          {editId === qrCode.id ? (
              <>
                  <video
                      src={`https://hopguides.s3.eu-central-1.amazonaws.com/videos/${qrCode.video}`}
                      controls
                      className="md:w-1/4 w-full h-auto rounded-lg shadow"
                      alt="QR Code Video"
                  />
                  <div className="flex flex-1 flex-wrap min-w-0 gap-2">
                      <input type="text" value={editLink} onChange={(e) => setEditLink(e.target.value)} className="flex-auto min-w-[650px] px-2 py-1 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent" placeholder="Link"/>
                      <input type="text" value={editText} onChange={(e) => setEditText(e.target.value)} className="flex-auto min-w-[650px] px-2 py-1 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent" placeholder="Text"/>
                      <input type="text" value={editCampaign} onChange={(e) => setEditCampaign(e.target.value)} className="flex-auto min-w-[650px] px-2 py-1 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent" placeholder="Campaign"/>
                      <input type="file" accept="video/*" onChange={handleFileChange1} className="flex-auto min-w-[600px]" />
                  </div>
                  <button onClick={() => handleSave(qrCode.id)} className="flex-none bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded transition duration-300">Save</button>
              </>
          ) : (
              <>
                <div className="flex flex-1 gap-2">
    <p className="flex-auto min-w-[500px] text-center">{qrCode.link}</p>
    <p className="flex-auto min-w-[500px] text-center">{qrCode.text}</p>
    <p className="flex-auto min-w-[500px] text-center">{qrCode.campaign}</p>
</div>
                  <button onClick={() => handleEdit(qrCode)} className="flex-none bg-gray-300 hover:bg-gray-500 text-black font-bold py-2 px-4 rounded transition duration-300">Edit</button>
              </>
          )}
      </div>
  );
};
const handleUpload = async () => {
  if (!videoFile) {
    alert('Please select a video file first.');
    return;
  }
  setLoading(true);

  try {
    // Fetch the pre-signed URL from your backend ${url}api/pnl/tour/d-id/qrcodevideo
    const response = await fetch(`${url}api/pnl/tour/d-id/generate-presigned-url?fileName=${encodeURIComponent(videoFile.name)}`);
    const data = await response.json();
    const preSignedUrl = data.url;


    console.log(preSignedUrl)
    // Upload the video file to S3
    const uploadResponse = await fetch(preSignedUrl, {
      method: 'PUT',
      headers: {
        'Content-Type': 'video/mp4',
      },
      body: videoFile,
    });

    if (uploadResponse.ok) {
      console.log(data.name)
      const qrcodeResponse = await fetch(`${url}api/pnl/tour/d-id/qrcodevideo`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          name: data.name,
          link: link,
          text: text,
          campaign: campaign

        }),
      });

      if (qrcodeResponse.ok) {
        console.log(qrcodeResponse)
        const qrCodeText = await qrcodeResponse.text(); // Use .text() for plain text response
        console.log(qrCodeText); // Logging the QR code text

        setQrCode(qrCodeText);

      }



      // Here, you might want to generate and set the QR code based on the uploaded video
    } else {
      alert('Upload failed');
    }
  } catch (error) {
    console.error('Error uploading video:', error);
    alert('Error uploading video.');
  } finally {
    setLoading(false);
  }
};





const renderVideoChange = () => {
  if (!videoFileChanged) return null;

  const videoURL = URL.createObjectURL(videoFileChanged);
  return <video src={videoURL} controls width="400"></video>;
};


const renderVideo = () => {
  if (!videoFile) return null;

  const videoURL = URL.createObjectURL(videoFile);
  return <video src={videoURL} controls width="400"></video>;
};

return (
  <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100 p-4">
            {loading && <LoadingOverlay />}
            <div className="space-y-4 w-full max-w-lg mx-auto text-center">
                <h1 className="text-2xl font-bold text-gray-800 mb-4">Upload and Generate QR</h1>
                <div>
                    <input type="text" value={link} onChange={(e) => setLink(e.target.value)} placeholder="Enter the link at the end of the video " className="w-full px-3 py-2 mb-4 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent" />
                    <input type="text" value={text} onChange={(e) => setText(e.target.value)} placeholder="Enter text at the end of the video " className="w-full px-3 py-2 border mb-4 border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent" />
                    <input type="text" value={campaign} onChange={(e) => setCampaign(e.target.value)} placeholder="Enter campaign in form: city_month_number " className="w-full px-3 mb-4 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent" />
                    <input type="file" accept="video/*" onChange={handleFileChange} className="file:mr-4 file:py-2 file:px-4 file:rounded-full file:border-0 file:text-sm file:font-semibold file:bg-violet-50 file:text-violet-700 hover:file:bg-violet-100" />
                    {renderVideo()}
                    <button onClick={handleUpload} className="px-4 mt-8 py-2 bg-blue-500 text-white font-bold rounded hover:bg-blue-700 transition duration-300">Upload Video</button>
                    {qrCode && <img src={qrCode} alt="QR Code" className="mt-4 mx-auto w-full max-w-md h-auto" />}
                </div>
            </div>

            <div className="flex justify-between mt-16   items-center w-full px-4 py-2">
                <div className="flex-1">
                    {/* Left space if needed */}
                </div>
                <input type="text" value={searchCampaign} onChange={handleSearchChange} placeholder="Search by campaign" className="w-1/3 px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent" />
            </div>

            <div className="w-full px-3 py-2 bg-white rounded-lg shadow-md overflow-hidden">
                <h2 className="text-xl font-bold text-gray-800 mb-4">QR Code List</h2>
                {filteredQrCodes.map((qrCode) => (
                    <div key={qrCode.id} className="flex flex-col md:flex-row justify-between items-center p-4 border-b last:border-b-0">
                         {renderEditableFields(qrCode)}
                    </div>
                ))}
            </div>
        </div>
 


);
}

export default Prompts;